'use client'

import Cart from '@/components/cart'
import type { SanityCartPerformance } from '@/components/cart/type'
import type { IFormattedLegend } from '@a24/av-sdk/seat-map-sdk'
import type { fetchCurrentOrder } from './action'

const CheckoutCart = ({
  cartLegends,
  currentOrder,
  cartPerformanceData
}: {
  currentOrder: Awaited<ReturnType<typeof fetchCurrentOrder>>
  cartPerformanceData: SanityCartPerformance[]
  cartLegends: IFormattedLegend[]
}) => {
  return (
    <Cart
      cartPerformanceData={cartPerformanceData}
      cartLegends={cartLegends}
      orderMiscItems={currentOrder.data.data.OrderItems}
      miscItemsDetails={currentOrder.data.data.MiscItemDetails}
      admissions={currentOrder.data.data.Admissions}
      order={currentOrder.data.data.Order}
    />
  )
}

export default CheckoutCart
